import styled from 'styled-components';

export const Table = styled.table`
    width: 100%;
    margin: 0;
    border-collapse: separate;
    border-bottom: 1px solid #dedede;
    padding: 10px 0 10px 0;
`;

export const Tr = styled.tr`
`;
